import {
  type EventHandler,
  type JSX,
  type FocusEvent as ReactFocusEvent,
  ReactNode,
  type PointerEvent as ReactPointerEvent,
} from 'react'

export type PopupProps = {
  children?: JSX.Element
  content?: ReactNode
  id?: string
  triggerEvents?: TriggerEvents
  inactive?: boolean
  contentClassName?: string
  contentWrapperClassName?: string
  popupOpenWrapperClassName?: string
  anchorClassName?: string
  Anchor?: Anchor
  preferredPopupPosition?: Position
  alignPopup?: Alignment
  marginInPx?: number
}
export type FocusAndPointerHandler = EventHandler<ReactFocusEvent<HTMLElement> | ReactPointerEvent<HTMLElement>> &
  ((event: FocusEvent | PointerEvent) => void)
export type PopupContainerProps = {
  onCloseTransitionEnd: () => void
  triggerRect: TriggerRectangle | null
  children: ReactNode
  id: string
  onPopupLeave: FocusAndPointerHandler
}

export const Position = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
} as const

export const Alignment = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  JUSTIFY: 'justify',
} as const

export type Position = (typeof Position)[keyof typeof Position]
export type Alignment = (typeof Alignment)[keyof typeof Alignment]
export type ElementWidth = {
  width: number
}

export type ElementSize = ElementWidth & {
  height: number
}

export type TriggerRectangle = ElementWidth & {
  top: number
  bottom: number
  left: number
  offsetY: number
  offsetX: number
}

export type PopupPosition = {
  x: number
  y: number
  anchorOffsetX: number
  position: Position
  width: number
}

export type TriggerEvent = 'hover' | 'focus' | 'click' | 'keypress'
export type TriggerEvents = Array<TriggerEvent> | ReadonlyArray<TriggerEvent>

export type AnchorProps = { position: Position; x: number; className?: string }
export type Anchor = React.FC<AnchorProps>
